import React, { useState } from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';

import Heading from 'components/heading';
import Link from 'components/link';

const themes = {
  narrow: 'narrow'
};

const AnchorLinkListBlock = ({ title, links, theme, ariaLiveTemplateText }) => {
  const [sectionLiveText, setSectionLiveText] = useState('');

  const handleOnLinkClick = text => {
    setSectionLiveText(ariaLiveTemplateText.replace('{section}', text));
  };

  return (
    <div
      className={cn('anchor-link-list', {
        [`anchor-link-list--${theme}`]: themes[theme]
      })}
    >
      <div className="anchor-link-list__title">
        {title && (
          <Heading
            theme={Heading.themes.h3PortalBold}
            color={Heading.colors.grey}
          >
            {title}
          </Heading>
        )}
      </div>
      {links && !!links.length && (
        <nav aria-label="Ankerliste">
          <ul className="anchor-link-list__list">
            {links
              .filter(link => link.text)
              .map(link => (
                <li className="anchor-link-list__list-item">
                  <Link
                    {...link}
                    showIcon={true}
                    iconIsAfterText={false}
                    color={Link.colors.grey}
                    theme={Link.themes.anchorLinkBlock}
                    animation={Link.animation.expand}
                    isAnchorLink={true}
                    onClick={() => handleOnLinkClick(link.text)}
                  />
                </li>
              ))}
          </ul>
        </nav>
      )}
      <div
        className="anchor-link-list__live-text"
        aria-live="polite"
        aria-atomic="true"
      >
        {sectionLiveText}
      </div>
    </div>
  );
};

AnchorLinkListBlock.propTypes = {
  title: PropTypes.string,
  links: PropTypes.arrayOf(Link.propTypes),
  theme: PropTypes.oneOf(Object.keys(themes)),
  ariaLiveTemplateText: PropTypes.string
};

AnchorLinkListBlock.propTypesMeta = {
  theme: 'exclude'
};

AnchorLinkListBlock.themes = themes;

export default AnchorLinkListBlock;
